import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IScheduleDetails } from './ISchedule';
import { Request } from '../../httpClient/serverApi/requests/Request';

// Keep this interface in-sync with ISchedule
export interface ICreateScheduleParams {
  name: string;
  scheduleType: string; // Hourly, Daily, Weekly, Monthly
  scheduleDetails: IScheduleDetails;
  scheduledAction: string; // Extract, Subscription
  priority: number;
  parallel: boolean;
}

export interface ICreateScheduleResult extends IResult {
  id: string;
}

export class CreateScheduleRequest extends Request<ICreateScheduleParams, ICreateScheduleResult> {
  constructor(params: ICreateScheduleParams) {
    super('createSchedule', params);
  }
}
